var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriggerHandIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.918,
    height: 13.393,
    viewBox: "0 0 16.918 13.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tap",
    transform: "translate(0 -53.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4432",
    transform: "translate(3.231 55.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    d: "M110.476 132.578l-2.651-2.912a1.374 1.374 0 0 0-1.908 0 1.319 1.319 0 0 0-.34.582 1.375 1.375 0 0 0-1.774.123 1.337 1.337 0 0 0-.342.582 1.375 1.375 0 0 0-1.773.123 1.338 1.338 0 0 0-.338.569l-1.25-1.245a1.35 1.35 0 0 0-1.909 1.908l4.8 4.8-2.845.447a1.579 1.579 0 0 0-1.35 1.556 1.059 1.059 0 0 0 1.057 1.057h6.647a3.857 3.857 0 0 0 2.743-1.136l1.108-1.109a3.872 3.872 0 0 0 .126-5.344zm-.625 4.846l-1.108 1.109a3.155 3.155 0 0 1-2.244.929h-6.646a.353.353 0 0 1-.352-.352.873.873 0 0 1 .749-.859l3.535-.555a.352.352 0 0 0 .195-.6l-5.289-5.289a.644.644 0 0 1 .912-.911l2.07 2.07.017.017 1.441 1.44a.352.352 0 1 0 .5-.5l-1.453-1.453a.645.645 0 0 1 .016-.9.657.657 0 0 1 .907 0l.693.694.012.012.736.735a.352.352 0 0 0 .5-.5l-.744-.744a.646.646 0 0 1 .013-.9.657.657 0 0 1 .906 0l.736.739h.008a.352.352 0 0 0 .49-.507l-.042-.042a.645.645 0 0 1 .015-.9.668.668 0 0 1 .9-.012l2.639 2.9a3.167 3.167 0 0 1-.1 4.371z",
    transform: "translate(-97.797 -129.283)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4434",
    transform: "translate(1.41 54.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4c5d6",
    id: "Path_2045",
    d: "M48.726 97.881a3.169 3.169 0 1 0-4.19 4.189.353.353 0 1 0 .29-.643 2.464 2.464 0 1 1 3.257-3.257.353.353 0 0 0 .643-.29z",
    className: "cls-1",
    transform: "translate(-42.666 -96.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4436",
    transform: "translate(0 53.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4435"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b4c5d6",
    id: "Path_2046",
    d: "M9 56.748a4.579 4.579 0 1 0-5.6 5.6.335.335 0 0 0 .09.012.352.352 0 0 0 .09-.693 3.874 3.874 0 1 1 4.739-4.739.35.35 0 0 0 .431.25.353.353 0 0 0 .25-.43z",
    className: "cls-1",
    transform: "translate(0 -53.344)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerHandIcon);
export default __webpack_public_path__ + "static/media/TriggerHandIcon.3b2530881c958d67528ae99200ed9aad.svg";
export { ForwardRef as ReactComponent };